
import React, { useState } from 'react';

import Header from '../Components/Header';
import Updates from '../Components/Updates';
import Pictures from '../Components/Pictures';

const Mikey = ({  }) => {

    let currentApp = 'None';


    const updatesHeight = {
        'None': '45%',
        'Updates': '80%',
        'Pictures': '0%'
    }
    const picturesHeight = {
        'None': '40%',
        'Updates': '0%',
        'Pictures': '80%'
    }


    return (
        <div 
        className='mikey-mode-container'
        >

            <Header
            title={"MIKEY MODE"}
            page={"Mikey"}/>

            <div
            style={{
                minHeight: '8%',
                width: '100%',
            }} />

            <div 
            style={{
                height: updatesHeight[currentApp],
                width: '100%',
            }}>
                <Updates title={'Updates'} app={'mikey'}/>
            </div>

            <div 
            style={{
                height: picturesHeight[currentApp],
                width: '100%',
            }}>
                <Pictures title={"Builder's Portfolio"} app={'mikey'}/>
                

            </div>
            
        </div>
    )


};

export default Mikey;